import type { FC } from "react";
import styled from "styled-components";
import { t } from "i18next";
import { Paragraph, Title } from "@smartsuite/react-ui/lib";
import { SolutionColorVariables } from "@smartsuite/types";
import type { SectionLabelKind } from "../graph/types";

/* Replica of the legacy Sidebar section headers ("When / this happens",
   "Then / do this") — markup and the .sidebar-title / .trigger-description
   rules from AutomationForm/Sidebar/style.tsx's StylesSidebar. Rendered
   INSIDE the RF node so React Flow measures label + card as one box and the
   layout spaces the stack accordingly. */
const StyledSectionLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .sidebar-title {
    color: ${SolutionColorVariables.sc1};
  }

  .trigger-description {
    padding-bottom: 10px;
  }
`;

export const NodeSectionLabel: FC<{ label: SectionLabelKind | undefined }> = ({
  label,
}) => {
  if (label === undefined) return null;
  return (
    <StyledSectionLabel data-testid={`section-label-${label}`}>
      <Title
        weight="bold"
        className="sidebar-title"
        size="xl"
        color="currentColor"
      >
        {label === "when" ? t("general.when") : t("automation-form.then")}
      </Title>
      <Paragraph className="trigger-description" weight="medium">
        {label === "when"
          ? t("automation-form.this-happens")
          : t("automation-form.do-this")}
      </Paragraph>
    </StyledSectionLabel>
  );
};
NodeSectionLabel.displayName = "NodeSectionLabel";
